'use strict'

import React, { useEffect, useState, Children, cloneElement } from 'react'
import PropTypes from 'prop-types';
import LoadingBlock from '../loadingBlock'

function ComponentDataLoader (props) {
  const [loaded, setLoaded] = useState(false)
  const [response, setResponse] = useState({})

  const targetComponent = cloneElement(
    Children.toArray(props.children)[0],
    { ...response, lang: props.lang }
  )

  const shouldShowLoader = props.loader !== false

  useEffect(() => {
    // Load component data
    let formData = new FormData()

    if (props.componentParams.hasOwnProperty('filter') && props.componentParams.filter.length)
      formData.append('filter', props.componentParams.filter)

    formData.append('template', props.componentParams.template)
    formData.append('params', props.componentParams.params)
    formData.append('component', props.componentParams.component)
    formData.append('lang', props.lang)
    formData.append('sessid', props.sessid)

    fetch('/local/async_comp_data.php', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => response.json())
      .then(response => {
        setResponse(response)
        setLoaded(true)
      })
      .catch(error => {
        console.error(error)
      })
  }, [])

  return (
    <>
      {
        loaded ?
          targetComponent :
          (shouldShowLoader ? <LoadingBlock/> : <></>)
      }
    </>
  )
}

export default ComponentDataLoader

ComponentDataLoader.propTypes = {
  children: PropTypes.element,
  componentParams: PropTypes.object,
  lang: PropTypes.string,
  sessid: PropTypes.string
}